(function () {
  var t = document.querySelector('[data-kzh-track]');
  if (t) {
    var input = t.querySelector('[data-kzh-track-num]');
    var msg = t.querySelector('[data-kzh-track-msg]');
    var go = function () {
      var n = (input.value || '').trim();
      msg.hidden = true;
      if (!n) { msg.textContent = t.getAttribute('data-enter'); msg.hidden = false; input.focus(); return; }
      if (!window.YQV5 || !window.YQV5.trackSingle) { msg.textContent = t.getAttribute('data-unavailable'); msg.hidden = false; return; }
      window.YQV5.trackSingle({ YQ_ContainerId: 'YQContainer', YQ_Height: 560, YQ_Fc: '0', YQ_Lang: t.getAttribute('data-lang'), YQ_Num: n });
    };
    t.querySelector('[data-kzh-track-go]').addEventListener('click', go);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
  }
  var r = document.querySelector('[data-kzh-reload]');
  var d = document.querySelector('[data-kz-drawer]');
  if (r && d && window.MutationObserver) {
    var opened = false;
    new MutationObserver(function () { if (!d.hidden) { opened = true; } else if (opened) { location.reload(); } }).observe(d, { attributes: true, attributeFilter: ['hidden'] });
  }
})();
